import React from 'react';
import PropTypes from 'prop-types';

import PhotoOrInitials from 'components/photo_or_initials';

import './styles.scss';

export default function DropdownItem({ props: [tag, tagify] }) {
  // HACK: Include "jsxRuntime" somewhere in the string representation of this function in a way
  //       that won't be stripped out during minification to force tagify to recognize this function
  //       as a React component, because we're on an older version of React DOM than Tagify expects.
  //       See https://github.com/yairEO/tagify/blob/71b8c8ec2e1325c090687c5e74fcde666cdd021e/src/react.tagify.jsx#L18
  return (
    <div
      aria-role="option"
      className={`jsxRuntime ${tagify.settings.classNames.dropdownItem} tag-group-${tag.group}`}
      role="option"
      tabIndex="0"
      value={tag.value}
    >
      <div className="d-flex">
        <PhotoOrInitials user={tag} />

        <div className="d-flex flex-column justify-content-center ms-3">
          {tag.label}
          <div className="fs-small">
            {tag.type !== 'User' && tag.email !== tag.label && tag.email}
          </div>
        </div>
      </div>
    </div>
  );
}

DropdownItem.propTypes = {
  props: PropTypes.array.isRequired,
};
